<template>
  <ul class="stepper">
    <li class="step" v-for="step of steps" :key="step.i">
      <i
        class="step-ico js-tooltip"
        :class="classFor(step.i, step.ico, step.consent)"
        :title="titleFor(step.i, step.name, step.consent)"
      ></i>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'stepper',
  props: {
    step: null,
    steps: null, // [{ name: 'step1', i: 0, ico: '' }, { ... } }
    title_prefix: null,
  },
  computed: {
    currentStep() {
      return this.steps.find((x) => x.name === this.step || x.error === this.step);
    },
    errorStep() {
      return this.steps.find((x) => x.error === this.step) && this.steps.find((x) => x.error === this.step).i;
    },
    i18nJS() {
      return window.i18nJS;
    },
    totalSteps() {
      return this.steps.length;
    },
  },
  methods: {
    classFor(i, ico, consent) {
      let css = '';
      if (this.stepDone(i)) {
        css = 'far done fa-';
      } else if (this.stepDoing(i)) {
        css = 'far doing fa-';
      } else if (this.stepError(i)) {
        css = 'far error fa-';
      } else if (this.stepAccepted(i)) {
        css = this.cssForAcceptedConsent(consent);
      } else {
        css = 'fa-light undone fa-';
      }
      css += ico;
      return css;
    },
    cssForAcceptedConsent(consent) {
      let answersArray = [];
      let css = '';
      Object.entries(consent.responses).map((item) => {
        answersArray.push(item[1].value);
      });
      let numberOfZeros = answersArray.filter((v) => v === 0).length;
      let numberOfOnes = answersArray.filter((v) => v === 1).length;
      let otherNumbers = answersArray.filter((v) => v !== 1 && v !== 0).length;
      if (numberOfZeros === 0 && numberOfOnes >= 1) {
        css = 'far done fa-';
      } else if (numberOfZeros >= 1 && numberOfOnes >= 1) {
        css = 'far twice fa-';
      } else if (numberOfZeros === 0 && numberOfOnes === 0) {
        css = 'far undoCheck fa-';
      } else {
        css = 'fa-light error fa-';
      }

      if (otherNumbers >= 1) {
        css = 'far twice fa-';
      }
      return css;
    },
    mounted() {
      setTimeout(() => {
        window.BTTooltip.tooltipInit($('.step-ico.js-tooltip'));
      }, 1000);
    },
    stepDone(i) {
      return this.currentStep && i <= this.currentStep.i && (!this.errorStep || i < this.errorStep);
    },
    stepDoing(i) {
      return this.currentStep && i == this.currentStep.i && !this.errorStep;
    },
    stepError(i) {
      return this.currentStep && i == this.currentStep.i && this.errorStep;
    },
    stepAccepted(i) {
      return i === 3;
    },
    titleFor(i, key, consent) {
      if (this.title_prefix && key) {
        if (this.stepDone(i)) {
          return i18nJS[this.title_prefix][key]['done'];
        } else if (this.stepDoing(i)) {
          return i18nJS[this.title_prefix][key]['doing'];
        } else if (this.stepError(i)) {
          return i18nJS[this.title_prefix][key]['error'];
        } else if (this.stepAccepted(i)) {
          var css = this.cssForAcceptedConsent(consent);
          var label = this.labelForAcceptedStep(css);
          return i18nJS[this.title_prefix][key][label];
        } else {
          return i18nJS[this.title_prefix][key]['undone'];
        }
      } else {
        return '';
      }
    },
    labelForAcceptedStep(css) {
      var label = '';
      if (css.includes('done')) {
        label = 'done';
      } else if (css.includes('twice')) {
        label = 'twice';
      } else if (css.includes('undoCheck')) {
        label = 'undone';
      } else {
        label = 'error';
      }
      return label;
    },
  },
};
</script>

<style lang="scss" scoped>
.stepper {
  align-content: space-between;
  display: flex;
  justify-content: center;
  flex-direction: row;
  margin: auto;
  width: inherit;
}
.step {
  display: flex;
  cursor: help;
  padding: 4px 10px;
  position: relative;
  & > .step-ico {
    width: 18px;
  }
}
%step {
  border: 2px solid;
  border-radius: 100px;
  padding: 10px;
  margin: auto;
  text-align: center;
}
.undone {
  @extend %step;
  background-color: lightgray;
  color: lightslategrey;
  border-color: white;
}
.undoCheck {
  @extend %step;
  background-color: lightgray;
  color: lightslategrey;
  border-color: white;
}
.doing {
  @extend %step;
  background-color: blue;
  color: white;
}
.done {
  @extend %step;
  background-color: green;
  color: white;
}
.error {
  @extend %step;
  background-color: red;
  color: white;
}
.twice {
  @extend %step;
  background-color: orange;
  color: white;
}
.step-ico::after {
  content: '';
  right: -22px;
  height: 2px;
  width: 32px;
  border-bottom: 2px solid lightgray;
  top: 45%;
  position: absolute;
}
.step-ico.done::after {
  border-bottom: 2px solid green;
}
.step:last-child > .step-ico::after {
  border-bottom: 0;
}
</style>
